import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {
    UploadReimbursementRatesRequest,
    ValidateReimbursementRatesRequest,
    ValidateReimbursementRatesResponse,
} from '@app/generated-api';
import { MileageReimbursementRate } from '@models/request';
import { getSiteBaseUrl } from '@utility/utility';
import { map, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class MileageReimbursementRateService {
    private http = inject(HttpClient);
    get(countryCode: string, date: Date) {
        const isoDate = date.toISOString().split('T')[0]; // get only date from ISO format, without time
        return this.http.get<MileageReimbursementRate>(
            `${getSiteBaseUrl()}/api/mileagereimbursementrates/currentRate?countryCode=${countryCode}&date=${isoDate}`
        );
    }

    uploadMileageReimbursementRates: (rates: UploadReimbursementRatesRequest[]) => Observable<boolean> = (rates) => {
        return this.http
            .post<boolean>(`${getSiteBaseUrl()}/api/v2/mileagereimbursementrates/upload`, rates, {
                observe: 'response',
            })
            .pipe(
                map((response) => {
                    if (response.status === 201) return true;
                    return false;
                })
            );
    };

    validateMileageReimbursementRates(
        rates: ValidateReimbursementRatesRequest[]
    ): Observable<ValidateReimbursementRatesResponse> {
        return this.http.post<ValidateReimbursementRatesResponse>(
            `${getSiteBaseUrl()}/api/v2/mileagereimbursementrates/validate`,
            rates
        );
    }
}
